module.exports = __webpack_public_path__ + "image/highlights_content_9c096.png";